import { render } from "./FormInputDate.vue?vue&type=template&id=9b533008&scoped=true"
import script from "./FormInputDate.vue?vue&type=script&lang=js"
export * from "./FormInputDate.vue?vue&type=script&lang=js"

import "./FormInputDate.vue?vue&type=style&index=0&id=9b533008&scoped=true&lang=css"

import exportComponent from "/home/pslcal/futaba-photo.net/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b533008"]])

export default __exports__